import { createAction } from "@reduxjs/toolkit";
import {
  FETCHING_HUB_LAYOUTS,
  FETCHING_HUB_LAYOUTS_SUCCEEDED,
  FETCHING_HUB_LAYOUTS_FAILED,
  FETCHING_HUB_LAYOUT,
  FETCHING_HUB_LAYOUT_SUCCEEDED,
  // FETCHING_HUB_LAYOUT_FAILED,
  // INVALIDATE_HUB_LAYOUT,
  UPDATING_HUB_LAYOUT,
  UPDATING_HUB_LAYOUT_SUCCEEDED,
  UPDATING_HUB_LAYOUT_FAILED,
  CLONE_HUB_LAYOUT,
  CLONING_HUB_LAYOUT_SUCCEEDED,
  CLONING_HUB_LAYOUT_FAILED,
  CREATE_HUB_SECTION,
  CREATING_HUB_SECTION_SUCCEEDED,
  CREATING_HUB_SECTION_FAILED,
  DELETING_HUB_SECTION,
  DELETING_HUB_SECTION_SUCCEEDED,
  DELETING_HUB_SECTION_FAILED,
  FETCHING_HUB_SECTION,
  FETCHING_HUB_SECTION_SUCCEEDED,
  FETCHING_HUB_SECTION_FAILED,
  DELETING_HUB_LAYOUT,
  DELETING_HUB_LAYOUT_SUCCEEDED,
  DELETING_HUB_LAYOUT_FAILED,
  UPDATING_HUB_SECTION,
  UPDATING_HUB_SECTION_SUCCEEDED,
  UPDATING_HUB_SECTION_FAILED,
  REARRANGE_HUB_LAYOUT,
  REARRANGING_HUB_LAYOUT_SUCCEEDED,
  INVALIDATE_HUB_LAYOUT_UPDATE,
  CREATING_STREAM,
  CREATING_STREAM_SUCCEEDED,
  CREATING_STREAM_FAILED,
  INVALIDATE_STREAM_CREATION,
  ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS,
  ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_SUCCEEDED,
  ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_FAILED,
  CREATE_HUB_LAYOUT,
  CREATING_HUB_LAYOUT_SUCCEEDED,  
  CREATING_HUB_LAYOUT_FAILED,
  INVALIDATE_HUB_LAYOUT_CREATION,
} from "./actionTypes";

import _  from "lodash"
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { CreateHubSectionRequest, CreateHubSectionResponse, FetchLayoutRequest, HubLayout, UpdateHubSectionRequest } from "../../types/hub";
import { CreateStreamError, CreateStreamRequest, CreateStreamResponse } from "src/types/streams";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const apiHubUrl = `${process.env.REACT_APP_HUB_API_URL}`;
const STREAMS_BASE_URL = `${apiUrl}/api/2.0/streams`;
const HUB_LAYOUT_URL_V2 = `${apiHubUrl}/hubs/3.0/layouts`;


export const hideSideMenu = createAction<boolean>("HIDE_SIDE_MENU");

//Fetch All Hub Layouts
export const fetchAllHubLayouts = createAction<boolean>(FETCHING_HUB_LAYOUTS);

const fetchAllHubLayoutsSucceeded = createAction<any>(
  FETCHING_HUB_LAYOUTS_SUCCEEDED,
);

const fetchAllHubLayoutsFailed = createAction<any>(FETCHING_HUB_LAYOUTS_FAILED);

const fetchAllHubLayoutsSaga = function* (
  action: ReturnType<typeof fetchAllHubLayouts>,
): any {
  const layoutsUrl = new URL(`${HUB_LAYOUT_URL_V2}/search`);;

  const data = {
    page: 0,
    limit: 50,
  }

  const fetchAllHubLayoutsAPI = () => {
    return axios({
      method: "POST",
      url: layoutsUrl.toString(),
      data: data
    }).then((response) => _.get(response, "data"));
  };

  try {
    const response = yield call(fetchAllHubLayoutsAPI);
    yield put(fetchAllHubLayoutsSucceeded(_.get(response, "data")));
  } catch (error) {
    yield put(fetchAllHubLayoutsFailed(error));
  }
};

//Fetch Hub Layout
export const fetchHubLayout =
  createAction<FetchLayoutRequest>(FETCHING_HUB_LAYOUT);

const fetchingHubLayoutSucceeded = createAction<HubLayout>(
  FETCHING_HUB_LAYOUT_SUCCEEDED,
);

const fetchHubLayoutSaga = function* (
  action: ReturnType<typeof fetchHubLayout>,
): any {
  const { id } = action.payload;

  const url = new URL(`${HUB_LAYOUT_URL_V2}/${id}`);

  const fetchHubLayoutAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchHubLayoutAPI);
    yield put(fetchingHubLayoutSucceeded(response));
  } catch {
    console.log("Error");
  }
};

export const invalidateHubUpdate = createAction(INVALIDATE_HUB_LAYOUT_UPDATE);
//Update Hub Layout
export const updateHubLayout = createAction<{id: string, layout: any, trackHubEditedEvent? : any }>(
  UPDATING_HUB_LAYOUT,
);

const updateHubLayoutSucceeded = createAction<any>(
  UPDATING_HUB_LAYOUT_SUCCEEDED,
);

const updateHubLayoutFailed = createAction<any>(UPDATING_HUB_LAYOUT_FAILED);

const updateHubLayoutSaga = function* (
  action: ReturnType<typeof updateHubLayout>,
): any {
  const {id, trackHubEditedEvent, layout } = action.payload;

  const url = new URL(`${HUB_LAYOUT_URL_V2}/${id}`);

  const updateHubLayoutAPI = () => {
    return axios({
      method: "PUT",
      url: url.toString(),
      data: layout,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateHubLayoutAPI);
    yield put(updateHubLayoutSucceeded(response));
    if(trackHubEditedEvent){
      trackHubEditedEvent(_.get(response, "name"));
    }
  } catch (error) {
    yield put(updateHubLayoutFailed(error));
  }
};

// Clone Hub Layout
export const cloneHubLayout = createAction<string>(CLONE_HUB_LAYOUT);

export const cloneHubLayoutSucceeded = createAction<any>(
  CLONING_HUB_LAYOUT_SUCCEEDED,
);

export const cloneHubLayoutFailed = createAction<any>(CLONING_HUB_LAYOUT_FAILED);

const cloneHubLayoutSaga = function* (
  action: ReturnType<typeof cloneHubLayout>,
): any {
  const layoutId = _.get(action, "payload.id", null);

  const url = new URL(`${HUB_LAYOUT_URL_V2}/${layoutId}/clone`);

  const cloneHubLayoutAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(cloneHubLayoutAPI);
    yield put(cloneHubLayoutSucceeded(response));
  } catch (error) {
    yield put(cloneHubLayoutFailed(error));
  }
};

//Delete Hub Layout
export const deleteHubLayout = createAction<string>(DELETING_HUB_LAYOUT);

const deleteHubLayoutSucceeded = createAction<any>(
  DELETING_HUB_LAYOUT_SUCCEEDED,
);

const deleteHubLayoutFailed = createAction<any>(DELETING_HUB_LAYOUT_FAILED);

const deleteHubLayoutSaga = function* (
  action: ReturnType<typeof deleteHubLayout>,
): any {
  const layoutId = action.payload;

  const url = new URL(`${HUB_LAYOUT_URL_V2}/${layoutId}`);
  const deleteHubLayoutAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    yield call(deleteHubLayoutAPI);
    yield put(deleteHubLayoutSucceeded(layoutId));
  } catch (error) {
    yield put(deleteHubLayoutFailed(error));
  }
};

//Fetch Hub Section
export const fetchHubSection = createAction<string>(FETCHING_HUB_SECTION);

const fetchHubSectionSucceeded = createAction<{id: string, response: any}>(
  FETCHING_HUB_SECTION_SUCCEEDED,
);

const fetchHubSectionFailed = createAction<any>(FETCHING_HUB_SECTION_FAILED);

const fetchHubSectionSaga = function* (
  action: ReturnType<typeof fetchHubSection>,
): any {
  const id = action.payload;

  const url = new URL(`${HUB_LAYOUT_URL_V2}/sections/${id}`);

  const fetchHubSectionAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchHubSectionAPI);
    yield put(fetchHubSectionSucceeded({id, response}));
  } catch (error) {
    yield put(fetchHubSectionFailed({id , error}));
  }
};

//Update Hub Section
export const updateHubSection = createAction<UpdateHubSectionRequest>(
  UPDATING_HUB_SECTION,
);

const updateHubSectionSucceeded = createAction<any>(
  UPDATING_HUB_SECTION_SUCCEEDED,
);

const updateHubSectionFailed = createAction<any>(UPDATING_HUB_SECTION_FAILED);

const updateHubSectionSaga = function* (
  action: ReturnType<typeof updateHubSection>,
): any {
  const { data, rowIndex } = action.payload;
  const url = new URL(`${HUB_LAYOUT_URL_V2}/sections/${_.get(data, "columns[0].section.id")}`);
  
  const updateHubSectionAPI = () => {
    return axios({
      method: "PUT",
      url: url.toString(),
      data: data,
    }).then((response) => {
      return { response : response.data, rowIndex }
    });
  };

  try {
    const response = yield call(updateHubSectionAPI);
    yield put(updateHubSectionSucceeded(response));
  } catch (error) {
    yield put(updateHubSectionFailed(error));
  }
};

export const createHubSection = createAction<CreateHubSectionRequest>(CREATE_HUB_SECTION);
const createHubSectionSucceeded = createAction<CreateHubSectionResponse>(
  CREATING_HUB_SECTION_SUCCEEDED,
);
const createHubSectionFailed = createAction<any>(CREATING_HUB_SECTION_FAILED);

const createHubSectionSaga = function* (
  action: ReturnType<typeof createHubSection>,
): any {
  const { data, rowIndex } = action.payload;

  const url = new URL(`${HUB_LAYOUT_URL_V2}/sections`);

  const createHubSectionAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      data: data,
    }).then((response) => {
      return { response : response.data, rowIndex, create: true }
    });
  };

  try {
    const response = yield call(createHubSectionAPI);
    yield put(createHubSectionSucceeded(response));
  } catch (error) {
    yield put(createHubSectionFailed(error));
  }
};

//Delete Hub Section
export const deleteHubSection = createAction<any>(DELETING_HUB_SECTION);

const deleteHubSectionSucceeded = createAction<any>(
  DELETING_HUB_SECTION_SUCCEEDED,
);

const deleteHubSectionFailed = createAction<any>(DELETING_HUB_SECTION_FAILED);

const deleteHubSectionSaga = function* (
  action: ReturnType<typeof deleteHubSection>,
): any {
  const { index, layoutId } = action.payload;

  const url = `${HUB_LAYOUT_URL_V2}/${layoutId}/rows/${index}`

  const deleteHubSectionAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteHubSectionAPI);
    yield put(deleteHubSectionSucceeded({response, index}));
  } catch (error) {
    yield put(deleteHubSectionFailed(error));
  }
};

//Rearrange Hub Layout
// export function rearrangeHubLayout(rowIndex, direction) {
//   return function (dispatch) {
//     dispatch(fetchingAction(REARRANGING_HUB_LAYOUT_SUCCEEDED, {
//       index: rowIndex,
//       direction: direction
//     }));
//   }
// }

export const rearrangeHubLayout = createAction<{
  rowIndex: number;
  direction: string;
}>(REARRANGE_HUB_LAYOUT);

const rearrangeHubLayoutSaga = function* (
  action: ReturnType<typeof rearrangeHubLayout>,
): any {
  try {

    // Dispatch the success action after processing
    yield put({
      type: REARRANGING_HUB_LAYOUT_SUCCEEDED,
      payload: action.payload,
    });
  } catch (error) {
    console.error("Error rearranging hub layout", error);
  }
};

export const createStream = createAction<CreateStreamRequest>(CREATING_STREAM);

const createStreamSucceeded = createAction<CreateStreamResponse>(CREATING_STREAM_SUCCEEDED);

const createStreamFailed = createAction<CreateStreamError>(CREATING_STREAM_FAILED);

const createStreamSaga = function* (
  action: ReturnType<typeof createStream>,
): any {
  const url = new URL(`${STREAMS_BASE_URL}`);

  const createStreamAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      data: action.payload,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createStreamAPI);
    yield put(createStreamSucceeded(response));
  } catch (error) {
    yield put(createStreamFailed({error}));
  }
};

//invalidate stream creation
export const invalidateStreamCreation = createAction(INVALIDATE_STREAM_CREATION);

//enable layout access for user groups
export const enableLayoutAccessForUserGroups = createAction<{layoutId: string, userGroups: any}>(ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS);

const enableLayoutAccessForUserGroupsSucceeded = createAction<any>(ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_SUCCEEDED);

const enableLayoutAccessForUserGroupsFailed = createAction<any>(ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_FAILED);

const enableLayoutAccessForUserGroupsSaga = function* (
  action: ReturnType<typeof enableLayoutAccessForUserGroups>,
): any {
  const url = new URL(`${HUB_LAYOUT_URL_V2}/${action.payload.layoutId}/access`);

  const enableLayoutAccessForUserGroupsAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      data: {userGroups: action.payload.userGroups},
    }).then((response) => response.data);
  };

  try {
    const response = yield call(enableLayoutAccessForUserGroupsAPI);
    yield put(enableLayoutAccessForUserGroupsSucceeded(response.data));
  } catch (error) {
    yield put(enableLayoutAccessForUserGroupsFailed(error));
  }
};

export const createHubLayout = createAction<void>(CREATE_HUB_LAYOUT); 
const creatingHubLayoutSucceeded = createAction<HubLayout>(CREATING_HUB_LAYOUT_SUCCEEDED);
const creatingHubLayoutFailed = createAction<any>(CREATING_HUB_LAYOUT_FAILED);

const createHubLayoutSaga = function* (
  action: ReturnType<typeof createHubLayout>,
): any {

  const createHubLayoutApi = () => {
    return axios({
      method: "POST",
      url: HUB_LAYOUT_URL_V2
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createHubLayoutApi);
    yield put(creatingHubLayoutSucceeded(response));
  } catch (error) {
    yield put(creatingHubLayoutFailed(error));
  }
};

export const invalidateLayoutCreation = createAction(INVALIDATE_HUB_LAYOUT_CREATION);

export default function* hubSaga() {
  yield takeEvery(FETCHING_HUB_LAYOUTS, fetchAllHubLayoutsSaga);

  yield takeEvery(FETCHING_HUB_LAYOUT, fetchHubLayoutSaga);
  yield takeEvery(UPDATING_HUB_LAYOUT, updateHubLayoutSaga);
  yield takeEvery(CREATE_HUB_SECTION, createHubSectionSaga);
  yield takeEvery(DELETING_HUB_LAYOUT, deleteHubLayoutSaga);
  yield takeEvery(CLONE_HUB_LAYOUT, cloneHubLayoutSaga)

  yield takeEvery(FETCHING_HUB_SECTION, fetchHubSectionSaga);
  yield takeEvery(UPDATING_HUB_SECTION, updateHubSectionSaga);
  yield takeEvery(DELETING_HUB_SECTION, deleteHubSectionSaga);
  yield takeEvery(REARRANGE_HUB_LAYOUT, rearrangeHubLayoutSaga);

  yield takeEvery(CREATING_STREAM, createStreamSaga);

  yield takeEvery(ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS, enableLayoutAccessForUserGroupsSaga);
  yield takeEvery(CREATE_HUB_LAYOUT, createHubLayoutSaga);

}
